import styled from 'styled-components';

export const StyledErrorPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    text-align: center;
    padding-top: 6em;
    padding-bottom: 5em;
    min-height: 30em;
`;
